import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AppRoutes } from '../../utils/enums/routes.enum';
import { AuthService } from '../auth/auth.service';

export const authGuard: CanActivateFn = () => {
  const router = inject(Router);
  const authService = inject(AuthService);
  const isLoggedIn = authService.isLoggedIn();

  if (!isLoggedIn) {
    router.navigate([AppRoutes.LOGIN]);
  }

  return isLoggedIn;
};
